import { h } from 'preact';
import { config } from '../../../shared/config';
import { siteType } from '../../../includecart/propTypes';

function StripeConnectButton(props) {
  let { site } = props;
  let csrfToken = Date.now();
  //let stripeConnectRedirectUrl = 'https://stripe.com/connect/default/oauth/test'; // Stripe default URL
  let stripeConnectRedirectUrl = `${config.appUrl}/account/auth/stripe`;
  let stripeClientId = config.stripe.connectClientId;
  let stripeState = site.id + '_' + csrfToken;
  let stripeConnectUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${stripeClientId}&scope=read_write&redirect_uri=${stripeConnectRedirectUrl}&state=${stripeState}`;

  return (
    <a href={stripeConnectUrl}><img src="/img/stripe/connect-blue/blue-on-light.png" /></a>
  );
}

StripeConnectButton.propTypes = {
  site: siteType.isRequired,
};

export default StripeConnectButton;
